import {MagazineEntryDto} from "../../dtos/magazine-entry-dto";
import * as moment from 'moment';
import { RecommenderDto } from '../../dtos/recommender-dto';

export class ItemRender{	
	
	constructor(private currentColume:HTMLElement,private isHero = false){
	}
	
	public renderRecommendation(recommendation: RecommenderDto, recoId?: string){
		var entryHtml = document.createElement("div");
		
		entryHtml.classList.add("_entry");
		entryHtml.classList.add('_recommenderHomeContainer')
		
		// Create div for label
		var label = document.createElement("div");

		// Add classes for label
		label.classList.add("titleSmall");
		label.classList.add("_type");
		label.classList.add("_category");

		label.innerHTML = 'Unsere Empfehlung für Sie';
		entryHtml.appendChild(label)

		// image
		var imageLink = document.createElement("a");
		imageLink.href = "/produktion/" + recommendation.produktion + "?recoId=" + recoId;
		var recommendationImage = document.createElement("img");
		recommendationImage.src = recommendation.image;

		imageLink.appendChild(recommendationImage)
		entryHtml.appendChild(imageLink)

		// textContainer 
		var textContainer = document.createElement("div");
		textContainer.classList.add("textContainer");
		entryHtml.appendChild(textContainer);
		
		// title
		var title = document.createElement("a");
		title.href = "/produktion/" + recommendation.produktion + "?recoId=" + recoId;
		title.classList.add('headline1');
		title.innerHTML = recommendation.name;
				
		textContainer.appendChild(title);
		
		// addition1
		var description1 = document.createElement("div");
		description1.classList.add('text1')		
		description1.innerHTML = recommendation.addition1
		
		textContainer.appendChild(description1);
		
		// addition2
		var description2 = document.createElement("div");
		description2.classList.add('text1')
		description2.innerHTML = recommendation.addition2
		
		textContainer.appendChild(description2);
		
		var moreLink = document.createElement("a");
		moreLink.classList.add("link2");
		moreLink.classList.add("_readMore");
		moreLink.innerHTML = "Mehr lesen ...";
		moreLink.href = "/produktion/" + recommendation.produktion + "?recoId=" + recoId;
		textContainer.appendChild(moreLink);
		
		// ticketContainer
		var ticketContainer = document.createElement("a");
		// Append recoId to the ticket link. This url could contain URL-parameters, so the recoId gets attached with help of the URL-Class
		var ticketUrl = new URL(recommendation.ticket)
		ticketUrl.searchParams.append('recoId', recoId)
		ticketContainer.href = ticketUrl.href;
		ticketContainer.target = "_blank";
		ticketContainer.classList.add("ticketContainer");
		
		var date = document.createElement("div");
		date.classList.add('ticketDay')
		var splitted = recommendation.beginDate.split(".");
		date.innerHTML = splitted[0]
		ticketContainer.appendChild(date);
		
		var month = document.createElement("div");		
		month.classList.add('ticketMonth')
		month.innerHTML = splitted[1]
		ticketContainer.appendChild(month);

		imageLink.appendChild(ticketContainer);
		this.currentColume.appendChild(entryHtml);
	}

	public render(item:MagazineEntryDto){
		var leftHtml = document.createElement("div");
		var rightHtml = document.createElement("div");
		var hasImage = item.image != null;
		var entryHtml = document.createElement("div");
		var entryDescriptionHtml = document.createElement("div");
		
		entryHtml.classList.add("_entry");
		entryHtml.appendChild(entryDescriptionHtml);
		entryDescriptionHtml.classList.add("_heroWrapper");
		if(!hasImage){
			entryHtml.classList.add("_noImage");
		}

		if(this.isHero){
			rightHtml.classList.add("_rightWrapper");
			leftHtml.classList.add("_leftWrapper");	
			entryDescriptionHtml.appendChild(rightHtml);
			entryDescriptionHtml.appendChild(leftHtml);				
		}
		
		if(item.type != null){
			// Create div for label
			var typeHtml = document.createElement("div");

			// Add classes for label
			typeHtml.classList.add("titleSmall");
			typeHtml.classList.add("_type");
			typeHtml.classList.add("_category");
			if(item.hero_teaser_labelcolor){
				typeHtml.classList.add(item.hero_teaser_labelcolor);
			}
			// Insert text of label (e.g. "HAUS ZWEI")
			typeHtml.innerHTML = item.type;

			// Append label to container depending on whether it's a hero teaser or not
			if(this.isHero){
				leftHtml.appendChild(typeHtml);
			}else{
				entryDescriptionHtml.appendChild(typeHtml);		
			}			
		}
		
		if(hasImage){
			var imageHtml = document.createElement("img");
			if(item.image != undefined){
				imageHtml.src = item.image;
			}
			if(item.imageAlt != undefined){
				imageHtml.alt = item.imageAlt;
				imageHtml.title = item.imageAlt;
			}
			

			var permalinkHtml = document.createElement("a");
			permalinkHtml.href = item.permaLink;
			permalinkHtml.appendChild(imageHtml);

			if(this.isHero){
				rightHtml.appendChild(permalinkHtml);
			} else{
				entryDescriptionHtml.appendChild(permalinkHtml);
			}
			
		}
		if(item.title != null){
			var titleHtml = document.createElement("div");			
			titleHtml.classList.add("_title");

			var permalinkHtml = document.createElement("a");
			if (item.hero_teaser_titlecolor) {
				permalinkHtml.classList.add(item.hero_teaser_titlecolor);
			}
			permalinkHtml.innerHTML = item.title;
			permalinkHtml.href = item.permaLink;
			titleHtml.appendChild(permalinkHtml);
			if(this.isHero){
				leftHtml.appendChild(titleHtml);				
			} else{
				titleHtml.classList.add("headline1");
				entryDescriptionHtml.appendChild(titleHtml);
			}
			
		}
		if(item.subTitle != null){
			var textHtml = document.createElement("div");
			textHtml.classList.add("text1");
			textHtml.classList.add("_subtitle");
			textHtml.innerHTML = item.subTitle;
			if(item.permaLink != null){
				var permalinkHtml = document.createElement("a");
				permalinkHtml.classList.add("link2");
				permalinkHtml.classList.add("_readMore");
				permalinkHtml.innerHTML = "Mehr lesen ...";
				permalinkHtml.href = item.permaLink;
				textHtml.appendChild(permalinkHtml);
			}
			if(this.isHero){
				if(hasImage){
					leftHtml.appendChild(textHtml);
				}else{
					rightHtml.appendChild(textHtml);
				}
			} else{
				entryDescriptionHtml.appendChild(textHtml);
			}
			
		}
		
		if(item.ticketLink != null && item.begin != null && item.end != null){
			let begin = moment(item.begin).toDate();
			const now = new Date();
			let ticketUrl = "";
			const nintyMinutes = new Date(now.getTime() - (90 * 60 * 1000));
			if(item.ticketLink && begin >= nintyMinutes){
				var ticketLinkWrapperHtml = document.createElement("div");
				var ticketIconHtml = document.createElement("span");
				var ticketLinkHtml = document.createElement("a");
			
				ticketLinkWrapperHtml.classList.add("_ticketWrapper");
				ticketLinkHtml.classList.add("link2");
				ticketIconHtml.classList.add("icon-ticket");
				ticketLinkHtml.title = "Tickets kaufen";
				ticketLinkHtml.innerHTML = "Tickets kaufen";
				ticketLinkHtml.target = "_blank";
				
				ticketLinkHtml.href = item.ticketLink;
				
				ticketLinkWrapperHtml.appendChild(ticketLinkHtml);
				ticketLinkHtml.appendChild(ticketIconHtml);
			
				if(this.isHero){
					if(hasImage){
						leftHtml.appendChild(ticketLinkWrapperHtml);
					}else{
						rightHtml.appendChild(ticketLinkWrapperHtml);
					}
				} else{
					entryDescriptionHtml.appendChild(ticketLinkWrapperHtml);
				}
			}
		}
		
		this.currentColume.appendChild(entryHtml);
	}
}